/**
 * This plugin implements alphabet index feature
 */
angular.module('datatables.alphabet', ['datatables']).config(function () {
    // Search function
    $.fn.dataTable.Api.register("alphabetSearch()", function (searchTerm) {
        this.iterator("table", function (context) {
            context.alphabetSearch = searchTerm;
        });
        return this;
    });
    // Recalculate the alphabet display for updated data
    $.fn.dataTable.Api.register("alphabetSearch.recalc()", function (searchTerm) {
        this.iterator("table", function (context) {
            draw(new $.fn.dataTable.Api(context), $("div.alphabet", this.table().container()), context);
        });
        return this;
    });
    // Search plug-in
    $.fn.dataTable.ext.search.push(function (context, searchData) {
        // Ensure that there is a search applied to this table before running it
        if (!context.alphabetSearch) {
            return true;
        }
        if (searchData[context.oInit.alphabetColumnIndex || 0].charAt(0).toUpperCase() === context.alphabetSearch.toUpperCase()) {
            return true;
        }
        return false;
    });
    // Private support methods
    function bin(data) {
        var letter, bins = {};
        for (var i = 0, ien = data.length; i < ien; i++) {
            letter = data[i].charAt(0).toUpperCase();
            if (bins[letter]) {
                bins[letter]++;
            }
            else {
                bins[letter] = 1;
            }
        }
        return bins;
    }
    function draw(table, alphabet, context) {
        alphabet.empty();
        alphabet.append("<label>Index:</label>");
        var columnIndex = context.oInit.alphabetColumnIndex || 0;
        var columnData = table.column(columnIndex).data();
        var bins = bin(columnData);
        $('<span class="clear active"/>')
            .data("letter", "")
            .data("match-count", columnData.length)
            .html("All")
            .appendTo(alphabet);
        for (var i = 0; i < 26; i++) {
            var letter = String.fromCharCode(65 + i);
            $("<span/>")
                .data("letter", letter)
                .addClass(!bins[letter] ? "empty" : "")
                .html(letter)
                .appendTo(alphabet);
        }
        $('<div class="alphabetInfo"></div>').appendTo(alphabet);
    }
    $.fn.dataTable.AlphabetSearch = function (context) {
        var table = new $.fn.dataTable.Api(context);
        var alphabet = $('<div class="alphabet"/>');
        draw(table, alphabet, context);
        // Trigger a search
        alphabet.on("click", "span", function () {
            alphabet.find(".active").removeClass("active");
            $(this).addClass("active");
            table.alphabetSearch($(this).data("letter")).draw();
        });
        // API method to get the alphabet container node
        this.node = function () {
            return alphabet;
        };
    };
    $.fn.DataTable.AlphabetSearch = $.fn.dataTable.AlphabetSearch;
    // Register a search plug-in
    $.fn.dataTable.ext.feature.push({
        fnInit: function (settings) {
            if (settings.oInit.alphabet !== false) {
                var search = new $.fn.dataTable.AlphabetSearch(settings);
                return search.node();
            }
        },
        cFeature: "A"
    });
});

//# sourceMappingURL=datatables-alphabet.plugin.js.map
